module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0746c_logo_200x200.13cd3391.png";